import { OrdemServico, OSTecnicoDeslocamento } from './ordem-servico.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class OrdemServicoService {

    constructor(private http: Http) {}

    getOrdemServicos(): Observable<OrdemServico[]> {
        return this.http.get(`${NTECH_API}/ordem-servico`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }

    gravarOrdemServico(ordemServico: OrdemServico): Observable<OrdemServico> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');

        // if ((ordemServico.Id !== undefined) && ((ordemServico.Id.length > 0) || (ordemServico.Id !== '0'))) {
        if ((ordemServico.Id !== undefined) && (ordemServico.Id !== 0)) {
            return this.http.put(`${NTECH_API}/ordem-servico/${ordemServico.Id}`,
                JSON.stringify(ordemServico),
                new RequestOptions({headers: headers}))
            .map(response => response.json())
            .catch(ErrorHandler.handleError);
        } else {
            return this.http.post(`${NTECH_API}/ordem-servico`, JSON.stringify(ordemServico), new RequestOptions({headers: headers}))
            .map(response => response.json())
            .catch(ErrorHandler.handleError);
        }
    }

    getOrdemServicoById(id: string): Observable<OrdemServico> {
        return this.http.get(`${NTECH_API}/ordem-servico/${id}`)
          .map(response => response.json())
          .catch(ErrorHandler.handleError);
    }

    getOrdemServicoTecnicoDeslocamento(IdOrdemServico: string): Observable<OSTecnicoDeslocamento> {
        return this.http.get(`${NTECH_API}/os-tecnico-deslocamento?IdOrdemServico=${IdOrdemServico}`)
          .map(response => response.json())
          .catch(ErrorHandler.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/ordem-servico/ordem-servico.service.ts